<template>
    <div :id="ids.priorityCategory" class="category">
        <div :id="ids.priorityHeading" class="category-heading flex-y-center">
            <span class="heading"><span v-if="ASSETS.PriorityType.Focused(this)">Focus: </span> {{ category.Category }}</span>
            <div class="flex-right">
                <PriorityTypeDateRange :priority="priority"/>
            </div>
        </div>
        <div class="flex flex-wrap projects">
            <List
                v-for="(list, l) in projects"
                :key="l"
                :projects="list"
                :mobile="mobile"
                :priorityType="priority.PriorityType"
                :selectedProject="selectedProject"
                :searching="searching"
                @project="$emit('project', $event)"
            />
        </div>
    </div>
</template>

<script>
import { ASSETS } from "@/assets/JS/Assets.js";
import PriorityTypeDateRange from "@/components/PriorityTypeDateRange.vue";
import List from "@/components/Projects/CategoryList/List.vue";

export default {
    name: "ProjectListCategory",
    props: {
        category: Object,
        priority: Object,
        mobile: Boolean,
        selectedProject: Object,
        searching: Boolean
    },
    components: {
        PriorityTypeDateRange,
        List
    },
    data: () => ({
        ids: {
            priorityHeading: "",
            priorityCategory: ""
        },
        ASSETS,
        projects: []
    }),
    beforeMount: function() {
        const focused = ASSETS.PriorityType.Focused(this);
        this.ids = {
            priorityHeading: focused ? "heading-category-focus" : "heading-category-archive",
            priorityCategory: focused ? "category-focus" : "category-archive"
        };

        // Create list of projects of they exist in project type
        for (const project of this.category.Types) {
            if (project.Projects.length) {
                this.projects.push(project);
            }
        }

    },
    emits: [ "project" ]
};
</script>